<template>
    <section class="pt-120 pb-120 mt-10 mt-lg-0">
        <div class="pb-60 br-bottom-n3">
            <div data-aos="zoom-in" class="page-heading">
                <h3 class="page-title fs-onefw-semibold n5-color mb-2 mb-md-3 text-center">
                    Contact
                </h3>
                <p class="fs-seven n5-color mb-4 mb-md-8 text-center">
                    Interested in hiring me for your project or just want to say hi?
                    You can fill in the contact form below or send me an email to
                    <a href="mailto:niel2264@gmail.com" class="p1-color">niel2264@gmail.com</a> .Want to
                    get connected? Follow me on the social channels below.
                </p>
                <div class="d-flex flex-wrap justify-content-center gap-2 align-items-center mt-4">
                    <!-- <a href="javascript:void(0)" class="social-icon">
                <i class="ph ph-facebook-logo p1-color"></i>
              </a> -->
                    <a href="https://www.github.com/niel22" class="social-icon">
                        <i class="ph ph-github-logo p1-color"></i>
                    </a>
                    <a href="https://www.x.com/codenovaniel" class="social-icon">
                        <i class="ph ph-x-logo p1-color"></i>
                    </a>
                    <a href="https://www.linkedin.com/in/novaniel" class="social-icon">
                        <i class="ph ph-linkedin-logo p1-color"></i>
                    </a>
                    <!-- <a href="javascript:void(0)" class="social-icon">
                <i class="ph ph-stack-overflow-logo p1-color"></i>
              </a>
              <a href="javascript:void(0)" class="social-icon">
                <i class="ph ph-youtube-logo p1-color"></i>
              </a> -->
                </div>
            </div>
        </div>

        <div class="container mt-8 mt-md-15">
            <div data-aos="fade-left" class="section-heading">
                <div class="d-flex align-items-center gap-2">
                    <div class="title-line"></div>
                    <h2 class="display-four n5-color fw-semibold">
                        Contact Details
                    </h2>
                </div>
                <p class="fs-seven n4-color mt-2 mt-md-4">
                    Feel free to reach out to me through any of the contact details below.
                </p>
            </div>

            <div data-aos="fade-up"
                class="d-flex flex-wrap gap-3 gap-md-6 align-items-center justify-content-between mt-8 mt-md-15">
                <div class="d-flex gap-3 align-items-center p-3 p-md-5 br1-left">
                    <i class="ph ph-device-mobile-camera p1-color fs-one"></i>
                    <div>
                        <span class="n5-color fs-five fw-semibold d-block mb-2">Phone</span>
                        <a href="tel:+2347040357987" class="n4-color fs-nine">+234-704035-7987</a>
                    </div>
                </div>
                <div class="d-flex gap-3 align-items-center p-3 p-md-5 br1-left">
                    <i class="ph ph-compass p1-color fs-one"></i>
                    <div>
                        <span class="n5-color fs-five fw-semibold d-block mb-2">Location</span>
                        <span class="n4-color fs-nine">Lagos, Nigeria</span>
                    </div>
                </div>
                <div class="d-flex gap-3 align-items-center p-3 p-md-5 br1-left">
                    <i class="ph ph-envelope-open p1-color fs-one"></i>
                    <div>
                        <span class="n5-color fs-five fw-semibold d-block mb-2">Email</span>
                        <a href="mailto:niel2264@gmail.com" class="n4-color fs-nine">niel2264@gmail.com</a>
                    </div>
                </div>
            </div>

            <div data-aos="zoom-in" class="mt-8 mt-md-15">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7945988.882897953!2d3.3792053835470917!3d9.082645657063188!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8b0f3663afc1%3A0x7cb82a6c84ee4d32!2sLagos%2C%20Nigeria!5e0!3m2!1sen!2sng!4v1719998700959!5m2!1sen!2sng"
                    style="border: 0" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                    class="w-100 h-400"></iframe>
            </div>
        </div>

    </section>

    <section class="pb-120">
        <div class="container">
            <div data-aos="fade-up" class="section-heading">
                <div class="d-flex align-items-center gap-2">
                    <div class="title-line"></div>
                    <h2 class="display-four n5-color fw-semibold">Get In Touch</h2>
                </div>
                <p class="fs-seven n4-color mt-2 mt-md-4">
                    Have a project in mind or need assistance? Feel free to reach out. Let's collaborate to bring your
                    ideas to life and create something amazing together.
                </p>
            </div>
            <form data-aos="zoom-in" id="contact-form" autocomplete="off"
                class="mt-8 mt-md-15 p-5 p-md-10 rounded-5 brn4">
                <div class="d-flex flex-wrap flex-md-nowrap gap-3 gap-md-6 mb-3 mb-md-6">
                    <div class="d-flex align-items-center gap-2 px-3 px-md-5 py-2 py-md-4 rounded-2 brn4 w-100">
                        <i class="ph ph-octagon p1-color fs-six mb-1"></i>
                        <input class="n5-color border-0" placeholder="Your Name*" type="text" id="name"
                            autocomplete="off" required />
                    </div>
                    <div class="d-flex align-items-center gap-2 px-3 px-md-5 py-2 py-md-4 rounded-2 brn4 w-100">
                        <i class="ph ph-envelope p1-color fs-six mb-1"></i>
                        <input class="n5-color border-0" placeholder="Email address*" type="email" id="email"
                            autocomplete="off" required />
                    </div>
                </div>
                <div class="d-flex flex-wrap flex-md-nowrap gap-3 gap-md-6">
                    <div class="d-flex align-items-center gap-2 px-3 px-md-5 py-2 py-md-4 rounded-2 brn4 w-100">
                        <i class="ph ph-device-mobile-camera p1-color fs-six mb-1"></i>
                        <input class="n5-color border-0" placeholder="Phone*" type="number" id="phone"
                            autocomplete="off" required />
                    </div>
                    <div class="d-flex align-items-center gap-2 px-3 px-md-5 py-2 py-md-4 rounded-2 brn4 w-100">
                        <i class="ph ph-map-pin p1-color fs-six mb-1"></i>
                        <input class="n5-color border-0" placeholder="Location*" type="text" id="location"
                            autocomplete="off" required />
                    </div>
                </div>
                <div class="mt-3 mt-md-6">
                    <textarea class="n5-color px-3 px-md-6 py-2 py-md-4 rounded-2 brn4 w-100 h-120"
                        placeholder="Your Message:" id="message" autocomplete="off"></textarea>
                </div>

                <div class="d-flex gap-2 align-items-center mt-3 mt-md-5">
                    <input id="check" type="checkbox" class="cursor-pointer checkbox-single" />
                    <label for="check" class="n4-color fs-nine cursor-pointer">
                        Save my name, email, and website in this browser for the next
                        time.
                    </label>
                </div>
                <button id="contact-submit-btn"
                    class="primary-btn fw-medium px-3 px-md-6 py-2 py-md-4 rounded-pill mt-5 mt-md-10">
                    Send Message
                </button>
            </form>
        </div>
    </section>
</template>

<script>
export default {
    name: "ContactPage"
}
</script>